import { render, staticRenderFns } from "./formCode.vue?vue&type=template&id=37cbee5a&scoped=true&"
import script from "./formCode.vue?vue&type=script&lang=js&"
export * from "./formCode.vue?vue&type=script&lang=js&"
import style0 from "./formCode.vue?vue&type=style&index=0&id=37cbee5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cbee5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37cbee5a')) {
      api.createRecord('37cbee5a', component.options)
    } else {
      api.reload('37cbee5a', component.options)
    }
    module.hot.accept("./formCode.vue?vue&type=template&id=37cbee5a&scoped=true&", function () {
      api.rerender('37cbee5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OwnWorkbench/formCode/formCode.vue"
export default component.exports